import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import { LinkPreview } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview/components/LinkPreview';
import { useElevioIntegration } from '../../../elevioIntegrationProvider';
import styles from './styles.module.scss';
import { parseElevioArticleUrls } from './utils/parseElevioLinks';
export function KnowledgeBaseLinkPreview({ text, className, }) {
    const [debouncedArticleUrls, setDebouncedArticleUrls] = useState([]);
    const { elevioIntegration } = useElevioIntegration();
    useDebounce(() => {
        if (!(elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.kbLink))
            return;
        setDebouncedArticleUrls(parseElevioArticleUrls(text, elevioIntegration.kbLink));
    }, 1000, [text, elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.kbLink]);
    if (debouncedArticleUrls.length === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: classNames(styles.listContainer, className) }, { children: debouncedArticleUrls.map((articleUrl) => (_jsx(LinkPreview, { articleUrl: articleUrl }, articleUrl))) })));
}
